/*=============================================== InputPhonePage ===============================================*/

import { useState } from "react"
import type { ChangeEvent } from "react"
import { Link } from "react-router-dom"
import { InputPhone } from "tsx-library-julseb"
import type { InputPhoneCountryType } from "tsx-library-julseb/types"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import {
    commonProps,
    inputLabel,
    validationObject,
    iconBoxicon,
    inputVariants,
    inputBackgroundColor,
    listDirection,
} from "data"

const InputPhonePage = () => {
    const [selectedCountry, setSelectedCountry] = useState<
        InputPhoneCountryType | undefined
    >(undefined)
    const [phone, setPhone] = useState("")
    const handlePhone = (e: ChangeEvent<HTMLInputElement>) =>
        setPhone(e.target.value)

    const items: ItemType[] = [
        {
            content: (
                <InputPhone
                    defaultCountry="fr"
                    selectedCountry={selectedCountry}
                    setSelectedCountry={setSelectedCountry}
                    value={phone}
                    onChange={handlePhone}
                    label="Phone number"
                />
            ),
            code: 'const [selectedCountry, setSelectedCountry] = useState(undefined)\nconst [phone, setPhone] = useState("")\nconst handlePhone = e => setPhone(e.target.value)\n\n<InputPhone defaultCountry="fr" selectedCountry={selectedCountry} setSelectedCountry={setSelectedCountry} value={phone} onChange={handlePhone} label="Phone number" />',
            codeTs: 'const [selectedCountry, setSelectedCountry] = useState<InputPhoneCountryType | undefined>(undefined)\nconst [phone, setPhone] = useState<string>("")\nconst handlePhone = (e: ChangeEvent<HTMLInputElement>) => setPhone(e.target.value)\n\n<InputPhone defaultCountry="fr" selectedCountry={selectedCountry} setSelectedCountry={setSelectedCountry} value={phone} onChange={handlePhone} label="Phone number" />',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "selectedCountry",
            type: "object",
            possibleString: (
                <>
                    See <Link to="/helpers/component-props">here</Link> for the
                    possibilities.
                </>
            ),
            required: true,
        },
        {
            subtitle: "setSelectedCountry",
            type: "function",
            required: true,
        },
        {
            subtitle: "defaultCountry",
            type: "string",
            possible: [],
            possibleString: (
                <>
                    Any <code>Alpha-2</code> Code from{" "}
                    <a
                        href="https://www.iban.com/country-codes"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        this list
                    </a>
                    .
                </>
            ),
            default: "de",
        },
        {
            subtitle: "searchIcon",
            intro: commonProps.addIconCapital,
            type: "string",
            default: iconBoxicon("search-alt"),
        },
        {
            subtitle: "searchPlaceholder",
            type: "string",
            default: "Search",
        },
        inputVariants(),
        inputBackgroundColor(),
        listDirection(),
        {
            subtitle: "textEmpty",
            intro: "Text showing when there's no result within the search.",
            type: "string",
            default: "Your search did not return any result.",
        },
        ...inputLabel(),
        ...validationObject(),
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default InputPhonePage
